import React from 'react';
import DailySelectionHeader from './DailySelectionHeader';
import DailyMetricCharts from './DailyMetricCharts';

/**
 * Renderiza el bloque DailyDetailView de SCAPP V2.
 *
 * @param {object} props
 * @param {object} props.v - Modelo de presentación y callbacks del panel.
 * @returns {React.ReactNode} Bloque visual sin estado local.
 */
export default function DailyDetailView({
  v
}) {
  return v.detNormal ? React.createElement(React.Fragment, null, React.createElement("div", {
    style: {
      "flex": "1",
      "minHeight": "0",
      "display": "flex",
      "flexDirection": "column",
      "gap": "0.740741vh"
    }
  }, v.text("\n        "), React.createElement(DailySelectionHeader, {
    v
  }), v.text("\n        "), React.createElement("div", {
    style: {
      "display": "flex",
      "alignItems": "center",
      "gap": "0.925926vh",
      "flexWrap": "wrap",
      "fontSize": "1.111111vh",
      "color": "#8793a6"
    }
  }, React.createElement("span", {}, v.text(v.detSummary)), v.czRuleOn ? React.createElement(React.Fragment, null, React.createElement("span", {
    style: {
      "display": "inline-flex",
      "alignItems": "center",
      "gap": "0.555556vh",
      "padding": "0.185185vh 0.37037vh 0.185185vh 0.925926vh",
      "borderRadius": "1.111111vh",
      "background": "oklch(0.66 0.19 42 / 0.18)",
      "border": "0.092593vh solid oklch(0.66 0.19 42 / 0.6)",
      "fontSize": "1.018519vh",
      "color": "#f0d9c8",
      "whiteSpace": "nowrap"
    }
  }, React.createElement("span", {
    style: {
      "width": "0.416667vw",
      "height": "0.740741vh",
      "borderRadius": "0.185185vh",
      "background": "oklch(0.66 0.19 42 / 0.6)"
    }
  }, null), v.text("Riesgo: " + v.czRuleT), React.createElement("button", {
    "onClick": v.czRuleOff,
    "title": "Quitar marca",
    style: {
      "border": "0",
      "background": "transparent",
      "color": "#f0d9c8",
      "cursor": "pointer",
      "fontSize": "1.203704vh",
      "padding": "0 0.37037vh"
    }
  }, v.text("×")))) : null), v.text("\n        "), React.createElement(DailyMetricCharts, {
    v
  }), v.text("\n        "))) : null;
}
